import { createStore } from 'zustand/vanilla'

export type ScrollPosition = { top: number; left: number }
export const navigationScrollStore = createStore<{
  owner: string | null
  pages: Record<string, ScrollPosition[]>
}>(() => ({ owner: null, pages: {} }))

export function readScrollPosition(owner: string, route: string) {
  if (navigationScrollStore.getState().owner !== owner)
    navigationScrollStore.setState({ owner, pages: {} })
  return navigationScrollStore.getState().pages[route]
}

export function saveScrollPosition(
  owner: string,
  route: string,
  positions: ScrollPosition[],
) {
  // A late cleanup from a previous account must not restore its memory.
  const state = navigationScrollStore.getState()
  if (state.owner !== owner) return
  const pages = { ...state.pages }
  delete pages[route]
  pages[route] = positions
  while (Object.keys(pages).length > 50) delete pages[Object.keys(pages)[0]!]
  navigationScrollStore.setState({ pages })
}
